import React from 'react';
import { AlertTriangle } from 'react-feather';

import {
  isCbsSubscriptionPaymentActionRequired,
  useSubscription,
} from '~/src/entities/subscription';
import { useStore } from '~/src/hooks/useMst';
import cbsSubscriptionsService from '~/src/services/api/cbsSubscriptionsService';
import { LAYOUT_TOAST_TYPES } from '~/src/components/PageLayout/Toasts';
import { useLayoutContext } from '~/src/contexts';
import useFeatureAccesses from '~/src/hooks/useFeatureAccesses';

const SubscriptionScaBannerContainer = () => {
  const store = useStore();
  const { showToast } = useLayoutContext();
  const { data } = useSubscription();
  const { isCbsIntegrationEnabled } = useFeatureAccesses();

  const handleClick = async () => {
    try {
      const orgFprint = store.user.currentOrganization?.fprint;

      if (orgFprint) {
        const response = await cbsSubscriptionsService.getResolveScaUrl(
          orgFprint,
        );

        window.open(response.customer_resolve_sca_url, '_blank');
      } else {
        showToast(LAYOUT_TOAST_TYPES.error, {
          message: 'Unable to authorize payment, please try again later.',
        });
      }
    } catch (error) {
      showToast(LAYOUT_TOAST_TYPES.error, {
        message: 'Unable to authorize payment, please try again later.',
      });
    }
  };

  if (!isCbsIntegrationEnabled || !data) return null;

  // Only show banner for admin organizations
  if (!store.user.currentOrganization?.admin) return null;

  // Make sure we are checking for CbsSubscription only
  if (!('last_payment_status' in data)) {
    return null;
  }

  // Only show banner if payment action is required
  if (!isCbsSubscriptionPaymentActionRequired(data)) return null;

  const description = 'You have payment(s) which require authorization.';

  return (
    <div className="flex justify-between p-4 bg-blue-100">
      <div className="flex">
        <div className="flex items-center justify-center mr-5">
          <AlertTriangle size="25px" />
        </div>
        <span>
          {description} Click{' '}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handleClick();
            }}
          >
            here
          </a>{' '}
          to complete the authorization.
        </span>
      </div>
    </div>
  );
};

export default SubscriptionScaBannerContainer;
